// extracted by mini-css-extract-plugin
module.exports = {"company":"HROrdersTable_company_3y49m"};